import { render, staticRenderFns } from "./StripeBridgeMetadataEditor.vue?vue&type=template&id=6d5ecc1c&scoped=true"
import script from "./StripeBridgeMetadataEditor.vue?vue&type=script&lang=js"
export * from "./StripeBridgeMetadataEditor.vue?vue&type=script&lang=js"
import style0 from "./StripeBridgeMetadataEditor.vue?vue&type=style&index=0&id=6d5ecc1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5ecc1c",
  null
  
)

export default component.exports